import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ReleaseNote } from 'src/app/services/release-notes.service';

@Component({
  selector: 'app-release-notes-popup',
  templateUrl: './release-notes-popup.component.html',
  styleUrls: ['./release-notes-popup.component.scss'],
  standalone: false
})
export class ReleaseNotesPopupComponent {
  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<ReleaseNotesPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { releaseNotes: ReleaseNote[] }
  ) { }

  openReleaseNote(note: ReleaseNote): void {
    const userType = localStorage.getItem('endUserType');
    const baseRoute = userType === 'specialist' ? '/specialist/support' : '/pcv/support';
    this.dialogRef.close('navigate');
    this.router.navigate([baseRoute], { queryParams: { tab: 'new-features', releaseNote: note._id } });
  }

  close(): void {
    this.dialogRef.close('dismiss');
  }
}
